import IMask from 'imask'

const Newsletter = () => {
  const phones = document.querySelectorAll('.mailpoet_paragraph:nth-of-type(2) input');

  phones.forEach(phone => {
      if (phone) {
          IMask(phone, {
            mask: '(00) 00000-0000',
          });
      }
  });
};

export default Newsletter;